export default function StyledButton({text, type}) {
    return (
        <button className="rounded-lg py-2 px-8 bg-bColor text-white" type={type}>
            {text}
        </button>
    )
}